import {Injectable} from '@angular/core';
import {catchError, Observable} from 'rxjs';
import {CommunicationService} from '../../http/communication.service';
import {
  CampaignFiltersRequest,
  CampaignFiltersResponse,
  CampaignOverviewRequest,
  CampaignOverviewResponse,
  ContentCategoryBreakdownRequest,
  ContentCategoryBreakdownResponse,
  InventoryQualityCsvResponse,
  InventoryQualityRequest,
  InventoryQualityResponse,
  RefreshRateDistributionRequest,
  RefreshRateDistributionResponse,
  SitesPerformanceRequest,
  SitesPerformanceResponse
} from './types';
import { formatDateRangeForFilters } from '../../utils/time';

@Injectable({
    providedIn: 'root',
})
export class CampaignService {
  constructor(private communicationService: CommunicationService) {
  }

  getCampaignOverview(body: CampaignOverviewRequest): Observable<CampaignOverviewResponse> {
    return this.communicationService
      .httpPost<CampaignOverviewResponse>('/dashboard/my-campaigns/overview', {...body, ...formatDateRangeForFilters(body)})
      .pipe(
        catchError((error) => {
          console.error('Error fetching campaign overview', error);
          throw error;
        })
      );
  }

  getInventoryQuality(body: InventoryQualityRequest): Observable<InventoryQualityResponse> {
    return this.communicationService
      .httpPost<InventoryQualityResponse>('/dashboard/my-campaigns/inventory-quality', {...body, ...formatDateRangeForFilters(body)})
      .pipe(
        catchError((error) => {
          console.error('Error fetching inventory quality data', error);
          throw error;
        })
      );
  }

  getInventoryQualityCsv(body: InventoryQualityRequest): Observable<InventoryQualityCsvResponse> {
    return this.communicationService
      .httpPost<InventoryQualityCsvResponse>('/dashboard/my-campaigns/inventory-quality/csv', {...body, ...formatDateRangeForFilters(body)})
      .pipe(
        catchError((error) => {
          console.error('Error fetching inventory quality csv data', error);
          throw error;
        })
      );
  }

  getContentCategoryBreakdown(body: ContentCategoryBreakdownRequest): Observable<ContentCategoryBreakdownResponse> {
    return this.communicationService
      .httpPost<ContentCategoryBreakdownResponse>('/dashboard/my-campaigns/content-category-breakdown', {...body, ...formatDateRangeForFilters(body)})
      .pipe(
        catchError((error) => {
          console.error('Error fetching content category breakdown', error);
          throw error;
        })
      );
  }

  getLowestPerformingSites(body: SitesPerformanceRequest): Observable<SitesPerformanceResponse> {
    return this.communicationService
      .httpPost<SitesPerformanceResponse>('/dashboard/my-campaigns/sites-performance', {...body, ...formatDateRangeForFilters(body)})
      .pipe(
        catchError((error) => {
          console.error('Error fetching lowest performing sites', error);
          throw error;
        })
      );
  }

  getRefreshRateDistribution(body: RefreshRateDistributionRequest): Observable<RefreshRateDistributionResponse> {
    return this.communicationService
      .httpPost<RefreshRateDistributionResponse>('/dashboard/my-campaigns/refresh-rate-distribution', {...body, ...formatDateRangeForFilters(body)})
      .pipe(
        catchError((error) => {
          console.error('Error fetching refresh rate distribution', error);
          throw error;
        })
      );
  }

  getCampaignFilters(body: CampaignFiltersRequest): Observable<CampaignFiltersResponse> {
        return this.communicationService
          .httpPost<CampaignFiltersResponse>('/dashboard/my-campaigns/filters', {...body, ...formatDateRangeForFilters(body)})
          .pipe(
            catchError((error) => {
              console.error('Error fetching campaign filters', error);
              throw error;
            })
          );
  }
}
